import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    BarChart,
    Bar,
    ResponsiveContainer
} from 'recharts';
import {useParams} from "react-router-dom";
import {withFirebase} from '../Firebase';
import {Scans} from './Scans'
import {Visits} from './Visits'
import {Segments} from './Segments'
import {Devices} from './Devices'
import {GenerateBillQRCode} from './GenerateBillQRCode/GenerateBillQRCode'
import {Campaigns} from './Campaigns'
import {ExportCSV} from './ExportCSV'
import Moment from 'moment';
import 'moment-timezone';
import {DateRangePicker} from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {Box, Grid} from '@theme-ui/components'
import {AuthUserContext, withAuthorization} from '../Session';
import 'react-tabs/style/react-tabs.css';
import './dashboard.css';
import NumberFormat from 'react-number-format';
import CrateCampaignsLayout from "./CreateCampaigns/CreateCampaignsLayout";
import Modal from "../Modal/Modal";
import Message from "../Modal/Message/Message";
import axiosInstance2ndGen from '../../axios-cloudfunctions2ndGen';
import Spinner from 'react-bootstrap/Spinner';
import sizeof from 'firestore-size'
import Button from 'react-bootstrap/Button';
import axios from "axios";
import {Predictions} from "./Predictions";
import CSVUploadComponent from "./CSVUploadComponent";
import {LoyaltyAnalytics} from "./LoyaltyAnalytics";
import {VoucherAnalytics} from "./VoucherAnalytics";

const DashboardPage = ({fakeUid}) => {
    const {uid} = useParams();
    return (
        <AuthUserContext.Consumer>
            {authUser => (
                <div className="min-h-screen bg-gray-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                        {/* Page Header */}
                        <div className="mb-6">
                            <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
                            <p className="text-gray-600 mt-1">Account: {authUser.email}</p>
                        </div>
                        <ValueCampaignForm authUser={authUser} uid={uid} fakeUid={fakeUid}/>
                    </div>
                </div>
            )}
        </AuthUserContext.Consumer>
    )
};

let useUID;

class ValueCampaignFormBase extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.fakeUid) {
            useUID = this.props.fakeUid;
        } else {
            useUID = this.props.authUser.uid;
        }
        this.unsubScans = null;
        this.unsubPredictions = null;
        this.companyUnsub = null;
        this.unsubCampaigns = null;
        this.unsubWhoUsedCampaigns = null;
        this.unsubDevices = null;
        this.unsubStores = null;
        const dateYesterday = new Date(Date.now());
        const date30DayAgo = new Date(Date.now());
        dateYesterday.setHours(0, 0, 0, 0);
        date30DayAgo.setDate(date30DayAgo.getDate() - 30);
        this.state = {
            company: null,
            predictions: [],
            loading: false,
            scans: [],
            scansForExport: [],
            aggregateScans: [],
            aggregateScansCount: [],
            aggregateScansPerStore: [],
            startDate: dateYesterday,
            endDate: new Date(Date.now()),
            visits: [],
            visitsForExport: [],
            visitsMap: {},
            campaigns: [],
            campaignsForExport: [],
            startDateCampaigns: date30DayAgo,
            endDateCampaigns: new Date(Date.now() + 24 * 60 * 60 * 1000),
            importDataFromSheet: [],
            selectedTabIndex: 0,
            campaignsList: [],
            companyLogoURL: '',
            showModal: false,
            modalMessage: '',
            devices: [],
            stores: [],
            campaignLoaded: false,
            whoUsedCampaignMap: [],
            whoSeenCampaignMap: [],
            lastVisibleVisit: null,
            selectedCampaignSubTab: 0,
            analyticsReport: null,
            voucherReport: null,
            campaignIdsInput: '',
        };

        this.sendCampaigns = this.sendCampaigns.bind(this);
        this.uploadCarouselImages = this.uploadCarouselImages.bind(this);
        this.checkCarouselImagesWithModal = this.checkCarouselImagesWithModal.bind(this);
        this.fetchCampaignsByIds = this.fetchCampaignsByIds.bind(this);
        this.fetchAnalyticsReport = this.fetchAnalyticsReport.bind(this);
        this.fetchVoucherReport = this.fetchVoucherReport.bind(this);
        this.fetchPredictions = this.fetchPredictions.bind(this);
        this.handleNewCampaignListUid = this.handleNewCampaignListUid.bind(this);
        this.handleDeviceActiveUpdate = this.handleDeviceActiveUpdate.bind(this);
        this.getCompanyLogoUrl = this.getCompanyLogoUrl.bind(this);
        this.handleDateSelect = this.handleDateSelect.bind(this);
        this.handleDateSelectCampaigns = this.handleDateSelectCampaigns.bind(this);
        this.getDataFromImportCSVComponent = this.getDataFromImportCSVComponent.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addFakeVisitForUid = this.addFakeVisitForUid.bind(this);
        this.fetchVisitsByUids = this.fetchVisitsByUids.bind(this);
        this.fetchScansByUids = this.fetchScansByUids.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true});

        this.companyUnsub = this.props.firebase.company(useUID).onSnapshot(docSnapshot => {
            Moment().locale(docSnapshot.data().country);
            this.setState({
                company: docSnapshot.data()
            });
        }, err => {
            console.log(`Encountered error: ${err}`);
        });

        this.unsubStores = this.fetchStores();
        this.unsubPredictions = this.fetchPredictions();
        this.getCompanyLogoUrl();
        this.fetchAnalyticsReport();
        this.fetchVoucherReport();
    }

    fetchPredictions() {
        console.log("Fetch for predictions");
        if (this.unsubPredictions !== null) this.unsubPredictions()
        console.log("Fetch for predictions pass");
        return this.props.firebase.predictionsForUid(useUID).onSnapshot(snapshot => {
            console.log("Looking for predictions");
            if (snapshot.empty) {
                console.log("Empty predictions");
                this.setState({
                    predictions: []
                })
                return
            }
            console.log("There is something for predictions");
            const list = [];
            snapshot.forEach(doc => {
                const {
                    userUid,
                    item,
                    averageIntervalDays,
                    lastPurchaseDate,
                    predictedNextPurchase,
                    createdAt,
                    purchaseHistoryDates
                } = doc.data();
                list.push({
                    userUid,
                    item,
                    averageIntervalDays,
                    lastPurchaseDate,
                    predictedNextPurchase,
                    createdAt,
                    purchaseHistoryDates,
                })
            });
            console.log("list", list)
            this.setState({
                predictions: list
            });
        })
    }

    /**
     * Fetch pre-aggregated analytics report from Firestore
     */
    async fetchAnalyticsReport() {
        try {
            console.log("Fetching analytics report for company:", useUID);
            const reportDoc = await this.props.firebase.db
                .collection('company').doc(useUID)
                .collection('analyticsReports').doc('latest')
                .get();

            if (reportDoc.exists) {
                const data = reportDoc.data();
                console.log("Analytics report found:", {
                    companyId: data.companyId,
                    hasVisits: !!data.visits,
                    hasScans: !!data.scans,
                    generatedAt: data.generatedAt
                });
                this.setState({ analyticsReport: data });
            } else {
                console.log("No analytics report found for company:", useUID);
                this.setState({ analyticsReport: null });
            }
        } catch (error) {
            console.error("Error fetching analytics report for", useUID, ":", error);
            this.setState({ analyticsReport: null });
        }
    }

    /**
     * Fetch pre-aggregated voucher report from Firestore
     */
    async fetchVoucherReport() {
        try {
            console.log("Fetching voucher report for company:", useUID);
            const reportDoc = await this.props.firebase.db
                .collection('company').doc(useUID)
                .collection('analyticsReports').doc('vouchers-latest')
                .get();

            if (reportDoc.exists) {
                const data = reportDoc.data();
                console.log("Voucher report found:", {
                    companyId: data.companyId,
                    totalCampaigns: data.summary?.totalVoucherCampaigns,
                    generatedAt: data.generatedAt
                });
                this.setState({ voucherReport: data });
            } else {
                console.log("No voucher report found for company:", useUID);
                this.setState({ voucherReport: null });
            }
        } catch (error) {
            console.error("Error fetching voucher report for", useUID, ":", error);
            this.setState({ voucherReport: null });
        }
    }

    fetchStores() {
        return this.props.firebase.storesForUid(useUID).onSnapshot(snapshot => {
            if (snapshot.empty) {
                console.log('No matching documents.');
                this.unsubDevices = this.fetchDevices();
                this.fetchVisitsWithoutListener();
                return;
            }
            const list = [];
            let index = 0;
            snapshot.forEach(doc => {
                const {name, storeId, zip, companyUid, location} = doc.data();
                index = index + 1;
                list.push({
                    index,
                    name,
                    storeId,
                    zip,
                    companyUid,
                    location
                })
            });
            this.setState({
                stores: list
            }, () => {
                this.unsubDevices = this.fetchDevices();
                this.fetchVisitsWithoutListener()
                this.unsubScans = this.fetchScans();
            });
        });
    }

    fetchDevices() {
        return this.props.firebase.devices(useUID).onSnapshot(snapshot => {
            if (snapshot.empty) {
                console.log('No matching documents.');
                return;
            }
            const deviceList = [];
            let index = 0;
            snapshot.forEach(doc => {
                const {
                    activateLocationCheck,
                    active,
                    appType,
                    created,
                    lastUpdated,
                    location,
                    locationLive,
                    phoneInfo,
                    uniqueID,
                    appVersion
                } = doc.data();
                index = index + 1;
                deviceList.push({
                    index,
                    uniqueID,
                    activateLocationCheck,
                    active,
                    appType,
                    createdDate: created.toDate(),
                    lastUpdatedDate: lastUpdated.toDate(),
                    location,
                    locationStore: location,
                    locationLive,
                    locationLiveName: locationLive,
                    appVersion: (typeof appVersion === "undefined") ? "1.74" : appVersion,
                    phoneInfo
                })
            });
            this.setState({
                devices: deviceList
            }, () => {
            });
        });
    }

    fetchVisitsWithoutListener(loadMore = false) {
        this.setState({loading: true});
        let {lastVisibleVisit} = this.state;
        if (loadMore === false) {
            lastVisibleVisit = null;
        }
        return this.props.firebase.visits(useUID, lastVisibleVisit)
            .get()
            .then(snapshot => {
                if (snapshot.empty) {
                    console.log('No matching documents.');
                }
                const visitList = [];
                const visitListForExport = [];
                const visitsMapNew = {};
                let totalSize = {size: 0};
                const t0 = performance.now();
                this.prepareVisitsData(visitList, visitListForExport, visitsMapNew, totalSize, snapshot, loadMore)

                const t1 = performance.now();
                console.log("Call to iterate all visits took " + (t1 - t0) + " milliseconds.")
                console.log("THE V SIZE: ", this.formatBytes(totalSize.size));

                let {lastVisibleVisit} = this.state;
                if (snapshot.docs.length > 0) {
                    lastVisibleVisit = snapshot.docs[snapshot.docs.length - 1];
                }

                this.setState({
                    visits: visitList,
                    visitsForExport: visitListForExport,
                    visitsMap: visitsMapNew,
                    loading: false,
                    lastVisibleVisit: lastVisibleVisit
                }, () => {
                });
                this.prepareScansDataAndPublishNewState()
            }).catch((err) => {
                console.log(`Encountered error: ${err}`);
            });
    }

    fetchVisitsByUids(uids) {
        this.setState({loading: true});

        // Firestore 'in' query supports max 30 items, so we batch if needed
        const BATCH_SIZE = 30;
        const batches = [];
        for (let i = 0; i < uids.length; i += BATCH_SIZE) {
            batches.push(uids.slice(i, i + BATCH_SIZE));
        }

        const promises = batches.map(batch =>
            this.props.firebase.company(useUID)
                .collection('visits')
                .where('uid', 'in', batch)
                .get()
        );

        return Promise.all(promises)
            .then(snapshots => {
                const visitList = [];
                const visitListForExport = [];
                const visitsMapNew = {};
                let totalSize = {size: 0};

                snapshots.forEach(snapshot => {
                    this.prepareVisitsData(visitList, visitListForExport, visitsMapNew, totalSize, snapshot, false);
                });

                // Re-index after combining batches
                visitList.forEach((visit, index) => {
                    visit.index = index + 1;
                });

                this.setState({
                    visits: visitList,
                    visitsForExport: visitListForExport,
                    visitsMap: visitsMapNew,
                    loading: false,
                    lastVisibleVisit: null // Reset pagination since we're doing a custom search
                });

                console.log(`Found ${visitList.length} visits for ${uids.length} UIDs`);
            })
            .catch((err) => {
                console.log(`Error fetching visits by UIDs: ${err}`);
                this.setState({loading: false});
            });
    }

    fetchScansByUids(uids) {
        this.setState({loading: true});

        // Firestore 'in' query supports max 30 items, so we batch if needed
        const BATCH_SIZE = 30;
        const batches = [];
        for (let i = 0; i < uids.length; i += BATCH_SIZE) {
            batches.push(uids.slice(i, i + BATCH_SIZE));
        }

        const promises = batches.map(batch =>
            this.props.firebase.scans(useUID)
                .where('uid', 'in', batch)
                .get()
        );

        return Promise.all(promises)
            .then(snapshots => {
                const {visitsMap} = this.state;
                const scansList = [];
                const scansListForExport = [];
                let index = 0;

                snapshots.forEach(snapshot => {
                    snapshot.forEach(doc => {
                        const {
                            uid,
                            time,
                            billNumber,
                            value,
                            city,
                            country,
                            companyCode,
                            storeId,
                            posId,
                            status,
                            username,
                            billTime,
                            campaignId,
                            voucher,
                            items,
                        } = doc.data();

                        if (typeof visitsMap[uid] === "undefined") {
                            this.addFakeVisitForUid(uid, visitsMap);
                        }

                        let scanTimeDiff = null;
                        if (typeof billTime !== "undefined" && billTime !== null) {
                            const diffInTime = time.toDate().getTime() - billTime.toDate().getTime();
                            const diffInSeconds = Math.round(diffInTime / 1000);
                            scanTimeDiff = Math.round((diffInSeconds) * 1000) / 1000;
                        }

                        index = index + 1;
                        scansList.push({
                            name: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                            index: index,
                            id: doc.id,
                            uid: visitsMap[uid],
                            totalValue: visitsMap[uid].value,
                            visits: visitsMap[uid].count,
                            billNumber,
                            value,
                            city,
                            country,
                            companyCode,
                            storeId,
                            posId,
                            status,
                            username,
                            date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                            time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                            timestamp: time.toDate(),
                            scanTimeDiff,
                            campaignId,
                            voucher,
                            items: typeof items !== 'undefined' ? items.map(item => typeof item === 'string' ? item : (item.quantity + " - " + item.name)).join('; ') : '',
                        });
                        scansListForExport.push({
                            uid,
                            totalValue: visitsMap[uid].value,
                            visits: visitsMap[uid].count,
                            billNumber,
                            value,
                            city,
                            country,
                            companyCode,
                            storeId,
                            posId,
                            status,
                            username,
                            date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                            time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                            timestamp: time.toDate(),
                            scanTimeDiff,
                            campaignId,
                            voucher,
                            items: typeof items !== 'undefined' ? items.map(item => typeof item === 'string' ? item : (item.quantity + " - " + item.name)).join('; ') : '',
                        });
                    });
                });

                this.setState({
                    scans: scansList,
                    scansForExport: scansListForExport,
                    loading: false,
                });

                console.log(`Found ${scansList.length} scans for ${uids.length} UIDs`);
            })
            .catch((err) => {
                console.log(`Error fetching scans by UIDs: ${err}`);
                this.setState({loading: false});
            });
    }

    prepareVisitsData(visitList, visitListForExport, visitsMapNew, totalSize, snapshot, loadMore = false) {
        let index = 0;
        if (loadMore) {
            const {visits, visitsForExport, visitsMap} = this.state;
            index = visits.length;
            visitList.push(...visits);
            visitListForExport.push(...visitsForExport);
            visitsMapNew = visitsMap
        }
        snapshot.forEach(doc => {
            totalSize.size = totalSize.size + sizeof(doc.data());
            const {
                uid,
                firstName,
                gender,
                birthday,
                count,
                value,
                periodFilled,
                lastVisit,
                lastSeen,
                listOfCities,
                listOfCompanyCodes,
                listOfStoresId,
                period,
                cityList
            } = doc.data();
            index = index + 1;
            visitList.push({
                name: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('DD.MM'),
                index: index,
                id: doc.id,
                uid,
                firstName,
                gender,
                birthday: typeof birthday !== 'undefined' && birthday !== null ? Moment.tz(birthday.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY') : '',
                count,
                value: Math.round(value * 100) / 100,
                periodFilled,
                listOfCities: typeof listOfCities !== 'undefined' && listOfCities !== null ? listOfCities.join(',') : '',
                listOfCompanyCodes: typeof listOfCompanyCodes !== 'undefined' && listOfCompanyCodes !== null ? listOfCompanyCodes.join(',') : '',
                listOfStoresId: typeof listOfStoresId !== 'undefined' && listOfStoresId !== null ? listOfStoresId.join(',') : '',
                cityList: typeof cityList !== 'undefined' && cityList !== null ? cityList.join(',') : '',
                date: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                time: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                timestamp: lastVisit.toDate(),
                lastSeen: lastSeen || null,
                period
            });
            visitListForExport.push({
                uid,
                firstName,
                gender,
                birthday: typeof birthday !== 'undefined' && birthday !== null ? Moment.tz(birthday.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY') : '',
                count,
                value: Math.round(value * 100) / 100,
                periodFilled,
                listOfCities: typeof listOfCities !== 'undefined' ? listOfCities.join(',') : '',
                listOfCompanyCodes: typeof listOfCompanyCodes !== 'undefined' ? listOfCompanyCodes.join(',') : '',
                listOfStoresId: typeof listOfStoresId !== 'undefined' && listOfStoresId !== null ? listOfStoresId.join(',') : '',
                cityList: typeof cityList !== 'undefined' && cityList !== null ? cityList.join(',') : '',
                date: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                time: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                timestamp: lastVisit.toDate()
            });
            visitsMapNew[uid] = {
                uid: uid,
                firstName: firstName,
                gender: gender,
                birthday: typeof birthday !== 'undefined' && birthday !== null ? Moment.tz(birthday.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY') : '',
                count: count,
                value: Math.round(value * 100) / 100,
                periodFilled: periodFilled,
                listOfCities: typeof listOfCities !== 'undefined' ? listOfCities.join(',') : '',
                listOfCompanyCodes: typeof listOfCompanyCodes !== 'undefined' ? listOfCompanyCodes.join(',') : '',
                listOfStoresId: typeof listOfStoresId !== 'undefined' && listOfStoresId !== null ? listOfStoresId.join(',') : '',
                cityList: typeof cityList !== 'undefined' && cityList !== null ? cityList.join(',') : '',
                date: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                time: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('H:mm:ss')
            }
        })
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    fetchScans() {
        this.setState({loading: true});
        const {startDate, endDate} = this.state;
        if (this.unsubScans !== null) this.unsubScans()
        return this.props.firebase.scans(useUID)
            .where('time', ">=", startDate)
            .where('time', "<=", endDate)
            .onSnapshot(snapshot => {
                    this.setState({scansSnapshot: snapshot})
                    this.prepareScansDataAndPublishNewState();
                }, err => {
                    console.log(`Encountered error: ${err}`);
                }
            );
    }

    prepareScansDataAndPublishNewState() {
        const {visitsMap, stores, scansSnapshot} = this.state;
        if (scansSnapshot.empty) {
            console.log('No matching documents.');
            //return;
        }

        const t0 = performance.now();
        const scansList = [];
        const scansListForExport = [];
        let index = 0;
        let totalSize = 0;
        scansSnapshot.forEach(doc => {
            totalSize += sizeof(doc.data());
            const {
                uid,
                time,
                billNumber,
                value,
                city,
                country,
                companyCode,
                storeId,
                posId,
                status,
                username,
                billTime,
                campaignId,
                voucher,
                items,
            } = doc.data();
            if (typeof visitsMap[uid] === "undefined") {
                console.error("UID doesn't exist in VISITS", uid);
                // add fake so the error is visible
                this.addFakeVisitForUid(uid, visitsMap);
            }
            let scanTimeDiff = null;
            if (typeof billTime !== "undefined" && billTime !== null) {
                const diffInTime = time.toDate().getTime() - billTime.toDate().getTime();
                const diffInSeconds = Math.round(diffInTime / 1000);
                scanTimeDiff = Math.round((diffInSeconds) * 1000) / 1000;
            }
            index = index + 1;
            scansList.push({
                name: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                index: index,
                id: doc.id,
                uid: visitsMap[uid],
                totalValue: visitsMap[uid].value,
                visits: visitsMap[uid].count,
                billNumber,
                value,
                city,
                country,
                companyCode,
                storeId,
                posId,
                status,
                username,
                date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                timestamp: time.toDate(),
                scanTimeDiff,
                campaignId,
                voucher,
                items: typeof items !== 'undefined' ? items.map(item => typeof item === 'string' ? item : (item.quantity + " - " + item.name)).join('; ') : '',
            });
            scansListForExport.push({
                uid,
                totalValue: visitsMap[uid].value,
                visits: visitsMap[uid].count,
                billNumber,
                value,
                city,
                country,
                companyCode,
                storeId,
                posId,
                status,
                username,
                date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                timestamp: time.toDate(),
                scanTimeDiff,
                campaignId,
                voucher,
                items: typeof items !== 'undefined' ? items.map(item => typeof item === 'string' ? item : (item.quantity + " - " + item.name)).join('; ') : '',
            });
        })

        console.log("THE S SIZE: ", this.formatBytes(totalSize));

        const totalValue = [...scansList].reduce((r, {value}) => {
            r += value;
            return r;
        }, 0);

        const aggregate = [...scansList].reduce((r, {name, uid, value}) => {
            if (!r[name]) r[name] = value;
            else r[name] += value;
            return r;
        }, {});

        const aggregateCount = [...scansList].reduce((r, {name}) => {
            if (!r[name]) r[name] = 1;
            else r[name] += 1;
            return r;
        }, {});

        const aggregateUsersPerDay = [...scansList].reduce((r, {name, uid}) => {
            if (!r[uid.uid + name]) {
                r[uid.uid + name] = 1;
                if (!r[name]) r[name] = 1
                else r[name] += 1;
            }
            return r;
        }, {});

        const aggregateScansStores = [...scansList].reduce((r, {storeId, city}) => {
            if (!r[storeId + "_" + city]) r[storeId + "_" + city] = 1;
            else r[storeId + "_" + city] += 1;
            return r;
        }, {});

        const aggregateUsersEver = [...scansList].reduce((r, {name, uid}) => {
            if (!r[uid.uid]) {
                r[uid.uid] = 1;
                if (!r[name]) r[name] = 1
                else r[name] += 1;
            }
            return r;
        }, {});

        const aggregateScansList = [];
        Object.keys(aggregate).map(name => {
            aggregateScansList.push({
                name: name,
                value: Math.round(aggregate[name] * 100) / 100,
            })
        });

        const aggregateScansCountList = [];
        Object.keys(aggregateCount).map(name => {
            aggregateScansCountList.push({
                name: name,
                uniquePerDay: Math.round(aggregateUsersPerDay[name] * 100) / 100,
                uniqueForPeriod: Math.round(aggregateUsersEver[name] * 100) / 100,
                count: Math.round(aggregateCount[name] * 100) / 100,
            })
        });
        const aggregateScansPerStore = [];
        Object.keys(aggregateScansStores).map(storeIdCity => {
            let storeName = "No Name";
            let storeId = storeIdCity.split("_")[0];
            let city = storeIdCity.split("_")[1];
            if (stores.filter(store => (store.storeId + "_" + store.zip) === storeIdCity).length > 0) {
                storeName = stores.filter(store => (store.storeId + "_" + store.zip) === storeIdCity)[0].name
                storeId = stores.filter(store => (store.storeId + "_" + store.zip) === storeIdCity)[0].storeId
                city = stores.filter(store => (store.storeId + "_" + store.zip) === storeIdCity)[0].zip
            }
            aggregateScansPerStore.push({
                storeId: storeId,
                storeName: storeName,
                city: city,
                count: Math.round(aggregateScansStores[storeIdCity] * 100) / 100,
            })
        });
        aggregateScansPerStore.sort(function (a, b) {
            return b.count - a.count;
        });

        const t1 = performance.now();
        console.log("Call to iterate all scans and data filtering took " + (t1 - t0) + " milliseconds.")

        this.setState({
            scans: scansList,
            totalValue: totalValue,
            scansForExport: scansListForExport,
            aggregateScans: aggregateScansList,
            aggregateScansCount: aggregateScansCountList,
            aggregateScansPerStore: aggregateScansPerStore,
            loading: false,
        });
    }

    fetchWhoUsedCampaign = (campaignId) => {

        return this.props.firebase.usersThatUsedCampaign(useUID, campaignId)
            .get()
            .then(snapshot => {
                return Promise.all([snapshot].concat(this.collectNotification(snapshot)))
            }).then(values => {
                let snapshot = values[0];
                let userNotificationListOfList = values.slice(1, values.length);
                let notificationMap = [];
                userNotificationListOfList.forEach(userNotificationList => {
                    let uid = null;
                    userNotificationList.forEach(userNotification => {
                        uid = userNotification.ref.path.split('/')[1];
                    });
                    if (uid !== null) {
                        notificationMap[uid] = "Exist"
                    }
                });

                const {whoUsedCampaignMap, campaigns} = this.state;
                let whoUsedCampaignList = [];
                snapshot.forEach(doc => {
                    const {uid, time, city, value, billNumber, posId, username, campaignId} = doc.data();
                    whoUsedCampaignList.push({
                        uid: uid,
                        time: time ? Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY HH:mm') : '-',
                        city: city,
                        value: value,
                        voucher: notificationMap[uid] === undefined ? "not exist" : "exist",
                        billNumber: billNumber,
                        // posId: posId,
                        // username: username,
                        // campaignId: campaignId,
                    })
                })
                whoUsedCampaignMap[campaignId] = whoUsedCampaignList;
                const newCampaigns = campaigns.map(obj =>
                    obj.id.id === campaignId ? {...obj, id: {id: campaignId, whoUsed: whoUsedCampaignList}} : obj
                );
                this.setState({
                    whoUsedCampaignMap: whoUsedCampaignMap,
                    campaigns: newCampaigns,
                });
            })
    }

    collectNotification(snapshot) {
        let notificationPromises = [];
        snapshot.forEach(doc => {
            const {uid, campaignId} = doc.data();
            notificationPromises.push(this.props.firebase.usersNotificationForCampaign(uid, campaignId).get())
        })
        return notificationPromises;
    }

    fetchWhoSeenCampaign = (campaignId) => {
        return this.props.firebase.usersThatSeenCampaign(useUID, campaignId)
            .get()
            .then(snapshot => {
                const {whoSeenCampaignMap, campaigns} = this.state;
                let whoSeenCampaignList = [];
                snapshot.forEach(doc => {
                    const {uid, time, city, posId, username, campaignId} = doc.data();
                    whoSeenCampaignList.push({
                        uid: uid,
                        time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY HH:mm'),
                    })
                })
                whoSeenCampaignMap[campaignId] = whoSeenCampaignList;
                const newCampaigns = campaigns.map(obj =>
                    obj.id.id === campaignId ? {...obj, id: {id: campaignId, whoSeen: whoSeenCampaignList}} : obj
                );
                this.setState({
                    whoSeenCampaignMap: whoSeenCampaignMap,
                    campaigns: newCampaigns,
                });
            })
    }

    fetchCampaigns() {
        this.setState({
            loading: true,
            campaignLoaded: true,
        });
        const {startDateCampaigns, endDateCampaigns} = this.state;
        if (this.unsubCampaigns !== null) this.unsubCampaigns()
        return this.props.firebase.campaigns(useUID)
            .where('time', ">=", startDateCampaigns)
            .where('time', "<=", endDateCampaigns)
            .get()
            .then(snapshot => {
                    const {visitsMap, whoUsedCampaignMap, whoSeenCampaignMap} = this.state;
                    if (snapshot.empty) {
                        console.log('No matching documents.');
                        //return;
                    }

                    const campaignsList = [];
                    const campaignsListForExport = [];
                    let index = 0;
                    let totalSize = 0;
                    const t0 = performance.now();
                    snapshot.forEach(doc => {
                        totalSize += sizeof(doc.data());
                        const {
                            campaignType,
                            activeInLastValue,
                            inactiveInLastValue,
                            spentLessThanValue,
                            spentMoreThanValue,
                            visitedLessThanValue,
                            visitedMoreThanValue,
                            city,
                            storeId,
                            offerValue,
                            numberOfUserToTarget,
                            image,
                            likes,
                            dislikes,
                            time,
                            userCountNotificationEnabled,
                            userCountNotificationDisabledNoExist,
                            userCountNotificationDisabled,
                            userTotal,
                            userDoesNotHaveToken,
                            userReceivedNotificationRecently,
                            campaignCost,
                            userList,
                        } = doc.data();
                        index = index + 1;
                        const notificationEnabled = typeof userCountNotificationEnabled !== 'undefined' && userCountNotificationEnabled !== null ? userCountNotificationEnabled : 0;
                        const notificationDoesnotExist = typeof userCountNotificationDisabledNoExist !== 'undefined' && userCountNotificationDisabledNoExist !== null ? userCountNotificationDisabledNoExist : 0;
                        campaignsList.push({
                            name: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                            index: index,
                            id: {
                                id: doc.id,
                                whoUsed: whoUsedCampaignMap[doc.id],
                                whoSeen: whoSeenCampaignMap[doc.id],
                            },
                            campaignType,
                            activeInLastValue,
                            inactiveInLastValue,
                            spentLessThanValue,
                            spentMoreThanValue,
                            visitedLessThanValue,
                            visitedMoreThanValue,
                            city,
                            storeId,
                            offerValue,
                            numberOfUserToTarget,
                            image,
                            likes: typeof likes !== 'undefined' && likes !== null ? likes.map((uid) => visitsMap[uid]) : [],
                            dislikes: typeof dislikes !== 'undefined' && dislikes !== null ? dislikes.map((uid) => visitsMap[uid]) : [],
                            date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                            time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                            timestamp: time.toDate(),
                            userTotal: userTotal,
                            userCountNotificationEnabled: (notificationEnabled + notificationDoesnotExist),
                            userCountNotificationDisabled: typeof userCountNotificationDisabled !== 'undefined' && userCountNotificationDisabled !== null ? userCountNotificationDisabled : 0,
                            userDoesNotHaveToken,
                            userReceivedNotificationRecently,
                            campaignCost,
                            userList: typeof userList !== 'undefined' ? userList : ''
                        });
                        campaignsListForExport.push({
                            campaignType,
                            activeInLastValue,
                            inactiveInLastValue,
                            spentLessThanValue,
                            spentMoreThanValue,
                            visitedLessThanValue,
                            visitedMoreThanValue,
                            city,
                            storeId,
                            offerValue,
                            numberOfUserToTarget,
                            image,
                            likes: typeof likes !== 'undefined' && likes !== null ? likes.join(',\n') : '',
                            dislikes: typeof dislikes !== 'undefined' && dislikes !== null ? dislikes.join(',\n') : '',
                            date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                            time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                            timestamp: time.toDate(),
                            userTotal: userTotal,
                            userCountNotificationEnabled: (notificationEnabled + notificationDoesnotExist),
                            userCountNotificationDisabled: typeof userCountNotificationDisabled !== 'undefined' && userCountNotificationDisabled !== null ? userCountNotificationDisabled : 0,
                            userDoesNotHaveToken,
                            userReceivedNotificationRecently,
                            campaignCost
                        });
                    })

                    console.log("THE C SIZE: ", this.formatBytes(totalSize));
                    const t1 = performance.now();
                    console.log("Call to iterate all campaigns took " + (t1 - t0) + " milliseconds.")

                    this.setState({
                        campaigns: campaignsList,
                        campaignsForExport: campaignsListForExport,
                        campaignLoaded: true,
                        loading: false,
                    });
                }
            ).catch(err => {
                console.log(`Encountered error: ${err}`);
            })
            ;
    }

    fetchCampaignsByIds(idsString) {
        if (!idsString || idsString.trim() === '') {
            alert('Unesite bar jedan campaign ID');
            return;
        }

        const ids = idsString.split(',').map(id => id.trim()).filter(id => id !== '');
        if (ids.length === 0) {
            alert('Unesite bar jedan validan campaign ID');
            return;
        }

        this.setState({
            loading: true,
            campaignLoaded: true,
        });

        // Firestore 'in' query supports max 10 items, so we need to batch
        const batchSize = 10;
        const batches = [];
        for (let i = 0; i < ids.length; i += batchSize) {
            batches.push(ids.slice(i, i + batchSize));
        }

        const promises = batches.map(batch =>
            this.props.firebase.campaigns(useUID)
                .where('__name__', 'in', batch)
                .get()
        );

        Promise.all(promises).then(snapshots => {
            const {visitsMap, whoUsedCampaignMap, whoSeenCampaignMap} = this.state;
            const campaignsList = [];
            const campaignsListForExport = [];
            let index = 0;

            snapshots.forEach(snapshot => {
                snapshot.forEach(doc => {
                    const {
                        campaignType,
                        activeInLastValue,
                        inactiveInLastValue,
                        spentLessThanValue,
                        spentMoreThanValue,
                        visitedLessThanValue,
                        visitedMoreThanValue,
                        title,
                        body,
                        time,
                        numberOfUserToTarget,
                        userCountNotificationEnabled,
                        userCountNotificationDisabledNoExist,
                        userCountNotificationDisabled,
                        userDoesNotHaveToken,
                        userReceivedNotificationRecently,
                        campaignCost,
                        userList,
                        userTotal,
                        likes,
                        dislikes,
                        image
                    } = doc.data();

                    index = index + 1;
                    const notificationEnabled = typeof userCountNotificationEnabled !== 'undefined' && userCountNotificationEnabled !== null ? userCountNotificationEnabled : 0;
                    const notificationDoesnotExist = typeof userCountNotificationDisabledNoExist !== 'undefined' && userCountNotificationDisabledNoExist !== null ? userCountNotificationDisabledNoExist : 0;

                    const whoUsedIt = typeof whoUsedCampaignMap[doc.id] !== 'undefined' ? whoUsedCampaignMap[doc.id] : {};
                    const whoSeenIt = typeof whoSeenCampaignMap[doc.id] !== 'undefined' ? whoSeenCampaignMap[doc.id] : {};

                    campaignsList.push({
                        index: index,
                        id: {id: doc.id, whoUsed: whoUsedIt, whoSeen: whoSeenIt, visitsMap: visitsMap},
                        campaignType,
                        activeInLastValue,
                        inactiveInLastValue,
                        spentLessThanValue,
                        spentMoreThanValue,
                        visitedLessThanValue,
                        visitedMoreThanValue,
                        title,
                        body,
                        numberOfUserToTarget,
                        image,
                        likes: typeof likes !== 'undefined' && likes !== null ? likes.join(',\n') : '',
                        dislikes: typeof dislikes !== 'undefined' && dislikes !== null ? dislikes.join(',\n') : '',
                        date: time ? Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY') : '',
                        time: time ? Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss') : '',
                        timestamp: time ? time.toDate() : null,
                        userTotal: userTotal,
                        userCountNotificationEnabled: (notificationEnabled + notificationDoesnotExist),
                        userCountNotificationDisabled: typeof userCountNotificationDisabled !== 'undefined' && userCountNotificationDisabled !== null ? userCountNotificationDisabled : 0,
                        userDoesNotHaveToken,
                        userReceivedNotificationRecently,
                        campaignCost,
                        userList: typeof userList !== 'undefined' ? userList : ''
                    });

                    campaignsListForExport.push({
                        campaignType,
                        title,
                        body,
                        numberOfUserToTarget,
                        likes: typeof likes !== 'undefined' && likes !== null ? likes.join(',\n') : '',
                        dislikes: typeof dislikes !== 'undefined' && dislikes !== null ? dislikes.join(',\n') : '',
                        date: time ? Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY') : '',
                        time: time ? Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss') : '',
                        userTotal: userTotal,
                        userCountNotificationEnabled: (notificationEnabled + notificationDoesnotExist),
                        userCountNotificationDisabled: typeof userCountNotificationDisabled !== 'undefined' && userCountNotificationDisabled !== null ? userCountNotificationDisabled : 0,
                        userDoesNotHaveToken,
                        userReceivedNotificationRecently,
                        campaignCost
                    });
                });
            });

            console.log(`Loaded ${campaignsList.length} campaigns by IDs`);

            this.setState({
                campaigns: campaignsList,
                campaignsForExport: campaignsListForExport,
                campaignLoaded: true,
                loading: false,
            });
        }).catch(err => {
            console.log(`Encountered error: ${err}`);
            this.setState({ loading: false });
        });
    }

    addFakeVisitForUid(uid, visitsMap) {
        visitsMap[uid] = {
            uid: uid,
            firstName: "No Visit",
            gender: "male",
            birthday: '',
            count: null,
            value: null,
            periodFilled: 7,
            listOfCities: '',
            listOfCompanyCodes: '',
            listOfStoresId: '',
            cityList: '',
            date: '',
            time: ''
        }
    }

    getCompanyLogoUrl() {
        this.props.firebase.storageReference('/Inc')
            .child(`${useUID}.png`)
            .getDownloadURL()
            .then(url => {
                this.setState({companyLogoURL: url})
            })
            .catch(err => console.error("Error retrieving Logo URL : ", err));
    }

    async uploadCarouselImages(carouselItems, now) {
        const uploadedItems = [];
        for (let i = 0; i < carouselItems.length; i++) {
            const item = carouselItems[i];
            const imagePathInStorage = `/${useUID}/${useUID}_${now}_carousel_${i}_${item.image.name}`;

            await this.props.firebase.storageReference(imagePathInStorage).put(item.image);
            const url = await this.props.firebase
                .storageReference(`/${useUID}`)
                .child(`${useUID}_${now}_carousel_${i}_${item.image.name}`)
                .getDownloadURL();

            uploadedItems.push({
                imageUrl: url,
                buttonText: item.buttonText || '',
                buttonLink: item.buttonLink || ''
            });
        }
        return uploadedItems;
    }

    sendCampaigns(dataForNewCampaign) {
        this.setState({loading: true});
        const now = Date.now();
        const hasCarouselItems = dataForNewCampaign.carouselItems && dataForNewCampaign.carouselItems.length > 0;

        if (typeof dataForNewCampaign.campaignsList != "undefined" && dataForNewCampaign.campaignsList.length > 0) {
            // ovde salemo kampanju na https://us-central1-digitalna-kartica.cloudfunctions.net/requestcampaignsandqueuenotifications
            // ovo je kampanja koja sadrzi listu ids iz text-area

            if (hasCarouselItems) {
                // Handle carousel items upload
                this.uploadCarouselImages(dataForNewCampaign.carouselItems, now)
                    .then(uploadedCarouselItems => {
                        // Verify all carousel images with modal
                        this.checkCarouselImagesWithModal(uploadedCarouselItems)
                            .then(isValid => {
                                if (isValid) {
                                    // Use first carousel image as fallback for older app versions
                                    const fallbackImage = uploadedCarouselItems.length > 0 ? uploadedCarouselItems[0].imageUrl : null;
                                    const updatedCampaignObject = {
                                        ...dataForNewCampaign,
                                        image: fallbackImage,
                                        carouselItems: uploadedCarouselItems
                                    };
                                    this.sendCustomCampaignRequest(updatedCampaignObject);
                                } else {
                                    console.log('Carousel images verification failed');
                                    this.setState({
                                        loading: false,
                                        modalMessage: "Carousel images verification failed. Please try again.",
                                        showModal: true
                                    });
                                }
                            });
                    })
                    .catch(error => {
                        console.log('ERROR uploading carousel images', error);
                        this.setState({showModal: true, modalMessage: 'Error uploading carousel images: ' + error});
                    });
            } else {
                const imagePathInStorage = `/${useUID}/${useUID}_${now}_${dataForNewCampaign.image.name}`;
                let task = this.props.firebase.storageReference(imagePathInStorage).put(dataForNewCampaign.image);
                task.on('state_changed',
                    (snapshot) => {
                    },
                    (error) => {
                        console.log('ERROR', error)
                        this.setState({showModal: true});
                        this.setState({modalMessage: 'Some error, try again later.' + error});
                    },
                    (complete) => {
                        this.props.firebase
                            .storageReference(`/${useUID}`)
                            .child(`${useUID}_${now}_${dataForNewCampaign.image.name}`)
                            .getDownloadURL()
                            .then(url => {
                                this.checkImageUrlWithModal(url)
                                    .then(isValid => {
                                        if (isValid) {
                                            const updatedCampaignObjectWithImageAddress = {
                                                ...dataForNewCampaign,
                                                image: url
                                            };
                                            this.sendCustomCampaignRequest(updatedCampaignObjectWithImageAddress);
                                        } else {
                                            console.log('Invalid or unreachable image URL.' + url);
                                            this.setState({
                                                loading: false,
                                                modalMessage: "Invalid or unreachable image URL.",
                                                showModal: true
                                            });
                                        }
                                    }).catch(error => {
                                    throw new Error(error);
                                });
                            }).catch(error => {
                            this.setState({showModal: true});
                            this.setState({modalMessage: 'Some error, try again later.' + error});
                            console.log('ERROR send Campaign', error)
                        })
                    });
            }
        } else {
            dataForNewCampaign.time = this.props.firebase.fireBaseTimestamp(new Date());

            if (hasCarouselItems) {
                // Handle carousel items upload
                this.uploadCarouselImages(dataForNewCampaign.carouselItems, now)
                    .then(uploadedCarouselItems => {
                        // Verify all carousel images with modal
                        this.checkCarouselImagesWithModal(uploadedCarouselItems)
                            .then(isValid => {
                                if (isValid) {
                                    // Use first carousel image as fallback for older app versions
                                    const fallbackImage = uploadedCarouselItems.length > 0 ? uploadedCarouselItems[0].imageUrl : null;
                                    const updatedCampaignObject = {
                                        ...dataForNewCampaign,
                                        image: fallbackImage,
                                        carouselItems: uploadedCarouselItems
                                    };
                                    this.sendCampaignFirebaseRequest(updatedCampaignObject);
                                } else {
                                    console.log('Carousel images verification failed');
                                    this.setState({
                                        loading: false,
                                        modalMessage: "Carousel images verification failed. Please try again.",
                                        showModal: true
                                    });
                                }
                            });
                    })
                    .catch(error => {
                        console.log('ERROR uploading carousel images', error);
                        this.setState({showModal: true, modalMessage: 'Error uploading carousel images: ' + error});
                    });
            } else if (dataForNewCampaign.image) {
                const imagePathInStorage = `/${useUID}/${useUID}_${now}_${dataForNewCampaign.image.name}`;
                let task = this.props.firebase.storageReference(imagePathInStorage).put(dataForNewCampaign.image);
                task.on('state_changed',
                    (snapshot) => {
                    },
                    (error) => {
                        console.log('ERROR', error)
                        this.setState({showModal: true});
                        this.setState({modalMessage: 'Some error, try again later.' + error});
                    },
                    (complete) => {
                        this.props.firebase
                            .storageReference(`/${useUID}`)
                            .child(`${useUID}_${now}_${dataForNewCampaign.image.name}`)
                            .getDownloadURL()
                            .then(url => {
                                this.checkImageUrlWithModal(url)
                                    .then(isValid => {
                                        if (isValid) {
                                            const updatedCampaignObjectWithImageAddress = {
                                                ...dataForNewCampaign,
                                                image: url
                                            };
                                            this.sendCampaignFirebaseRequest(updatedCampaignObjectWithImageAddress);
                                        } else {
                                            console.log('Invalid or unreachable image URL.' + url);
                                            this.setState({
                                                loading: false,
                                                modalMessage: "Invalid or unreachable image URL.",
                                                showModal: true
                                            });
                                        }
                                    });
                            }).catch(error => {
                            this.setState({showModal: true});
                            this.setState({modalMessage: 'Some error, try again later.' + error});
                            console.log('ERROR send Campaign', error)
                        })
                    });
            } else {
                this.sendCampaignFirebaseRequest(dataForNewCampaign)
            }
        }
    };

    checkImageUrlWithModal(url) {
        return new Promise((resolve) => {
            const img = new Image();

            img.onload = function () {
                // Create a modal overlay element
                const modalOverlay = document.createElement('div');
                modalOverlay.style.position = 'fixed';
                modalOverlay.style.top = '0';
                modalOverlay.style.left = '0';
                modalOverlay.style.width = '100%';
                modalOverlay.style.height = '100%';
                modalOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                modalOverlay.style.display = 'flex';
                modalOverlay.style.alignItems = 'center';
                modalOverlay.style.justifyContent = 'center';
                modalOverlay.style.zIndex = '9999';

                // Create a modal content container
                const modalContent = document.createElement('div');
                modalContent.style.backgroundColor = '#fff';
                modalContent.style.padding = '20px';
                modalContent.style.borderRadius = '8px';
                modalContent.style.textAlign = 'center';
                modalContent.style.maxWidth = '90%';
                modalContent.style.boxSizing = 'border-box';

                // Optionally, style the image (e.g., max width)
                img.style.maxWidth = '400px';
                img.style.width = '100%';  // This ensures the image scales down if needed.
                img.style.height = 'auto';

                // Append the image to the modal content
                modalContent.appendChild(img);

                // Create a container for the buttons
                const buttonContainer = document.createElement('div');
                buttonContainer.style.marginTop = '20px';

                // Create the "Looks good" button
                const confirmButton = document.createElement('button');
                confirmButton.innerText = 'Looks good';
                confirmButton.style.marginRight = '10px';
                confirmButton.style.padding = '10px 20px';

                // Create the "Does not look good" button
                const cancelButton = document.createElement('button');
                cancelButton.innerText = 'Does not look good';
                cancelButton.style.padding = '10px 20px';

                // When the user clicks "Looks good"
                confirmButton.addEventListener('click', () => {
                    document.body.removeChild(modalOverlay);
                    resolve(true);
                });

                // When the user clicks "Does not look good"
                cancelButton.addEventListener('click', () => {
                    document.body.removeChild(modalOverlay);
                    resolve(false);
                });

                // Append buttons to the container and container to modal content
                buttonContainer.appendChild(confirmButton);
                buttonContainer.appendChild(cancelButton);
                modalContent.appendChild(buttonContainer);

                // Append modal content to overlay and overlay to the document body
                modalOverlay.appendChild(modalContent);
                document.body.appendChild(modalOverlay);
            };

            img.onerror = function () {
                // If the image fails to load, resolve as false immediately
                resolve(false);
            };

            // Trigger the loading
            img.src = url;
        });
    }

    checkCarouselImagesWithModal(carouselItems) {
        return new Promise((resolve) => {
            // Preload all images first
            const imagePromises = carouselItems.map((item, index) => {
                return new Promise((imgResolve) => {
                    const img = new Image();
                    img.onload = () => imgResolve({ success: true, img, item, index });
                    img.onerror = () => imgResolve({ success: false, item, index });
                    img.src = item.imageUrl;
                });
            });

            Promise.all(imagePromises).then((results) => {
                const failedImages = results.filter(r => !r.success);
                if (failedImages.length > 0) {
                    resolve(false);
                    return;
                }

                // Create modal overlay
                const modalOverlay = document.createElement('div');
                modalOverlay.style.position = 'fixed';
                modalOverlay.style.top = '0';
                modalOverlay.style.left = '0';
                modalOverlay.style.width = '100%';
                modalOverlay.style.height = '100%';
                modalOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                modalOverlay.style.display = 'flex';
                modalOverlay.style.alignItems = 'center';
                modalOverlay.style.justifyContent = 'center';
                modalOverlay.style.zIndex = '9999';

                // Create modal content
                const modalContent = document.createElement('div');
                modalContent.style.backgroundColor = '#fff';
                modalContent.style.padding = '20px';
                modalContent.style.borderRadius = '8px';
                modalContent.style.textAlign = 'center';
                modalContent.style.maxWidth = '90%';
                modalContent.style.maxHeight = '90%';
                modalContent.style.overflow = 'auto';
                modalContent.style.boxSizing = 'border-box';

                // Add title
                const title = document.createElement('h3');
                title.innerText = `Verify Carousel Images (${carouselItems.length} images)`;
                title.style.marginBottom = '20px';
                modalContent.appendChild(title);

                // Create image grid container
                const imageGrid = document.createElement('div');
                imageGrid.style.display = 'grid';
                imageGrid.style.gridTemplateColumns = 'repeat(auto-fit, minmax(200px, 1fr))';
                imageGrid.style.gap = '15px';
                imageGrid.style.marginBottom = '20px';

                // Add all images
                results.forEach((result) => {
                    const imageContainer = document.createElement('div');
                    imageContainer.style.border = '2px solid #ddd';
                    imageContainer.style.borderRadius = '8px';
                    imageContainer.style.padding = '10px';
                    imageContainer.style.textAlign = 'center';

                    // Image number label
                    const label = document.createElement('div');
                    label.innerText = `Image #${result.index + 1}`;
                    label.style.fontWeight = 'bold';
                    label.style.marginBottom = '8px';
                    imageContainer.appendChild(label);

                    // Image
                    result.img.style.maxWidth = '100%';
                    result.img.style.maxHeight = '200px';
                    result.img.style.objectFit = 'contain';
                    imageContainer.appendChild(result.img);

                    // Button info if present
                    if (result.item.buttonText) {
                        const btnInfo = document.createElement('div');
                        btnInfo.style.marginTop = '8px';
                        btnInfo.style.fontSize = '12px';
                        btnInfo.style.color = '#666';
                        btnInfo.innerText = `Button: "${result.item.buttonText}"`;
                        imageContainer.appendChild(btnInfo);
                    }

                    imageGrid.appendChild(imageContainer);
                });

                modalContent.appendChild(imageGrid);

                // Button container
                const buttonContainer = document.createElement('div');
                buttonContainer.style.marginTop = '20px';

                // Confirm button
                const confirmButton = document.createElement('button');
                confirmButton.innerText = 'All images look good';
                confirmButton.style.marginRight = '10px';
                confirmButton.style.padding = '12px 24px';
                confirmButton.style.backgroundColor = '#28a745';
                confirmButton.style.color = '#fff';
                confirmButton.style.border = 'none';
                confirmButton.style.borderRadius = '4px';
                confirmButton.style.cursor = 'pointer';
                confirmButton.style.fontSize = '16px';

                // Cancel button
                const cancelButton = document.createElement('button');
                cancelButton.innerText = 'Images do not look good';
                cancelButton.style.padding = '12px 24px';
                cancelButton.style.backgroundColor = '#dc3545';
                cancelButton.style.color = '#fff';
                cancelButton.style.border = 'none';
                cancelButton.style.borderRadius = '4px';
                cancelButton.style.cursor = 'pointer';
                cancelButton.style.fontSize = '16px';

                confirmButton.addEventListener('click', () => {
                    document.body.removeChild(modalOverlay);
                    resolve(true);
                });

                cancelButton.addEventListener('click', () => {
                    document.body.removeChild(modalOverlay);
                    resolve(false);
                });

                buttonContainer.appendChild(confirmButton);
                buttonContainer.appendChild(cancelButton);
                modalContent.appendChild(buttonContainer);

                modalOverlay.appendChild(modalContent);
                document.body.appendChild(modalOverlay);
            });
        });
    }

    sendCustomCampaignRequest(dataForNewCampaign) {

        if (dataForNewCampaign.campaignsList.length > 0) {
            this.props.firebase.currentUserAuth().getIdToken(false).then(idToken => {
                const config = {
                    headers: {
                        "Authorization": "Bearer " + idToken,
                        "Content-Type": "application/json",
                    }
                };
                axiosInstance2ndGen.post(
                    'requestcampaignsandqueuenotifications2nd',
                    JSON.stringify(dataForNewCampaign), config
                )
                    .then(() => {
                        this.setState({
                            loading: false,
                            modalMessage: "Success!!!",
                            showModal: true
                        });
                    })
                    .catch(err => {
                            console.error('ERROR send Custom Campaign', err);
                            this.setState({
                                loading: false,
                                modalMessage: "Some error, try again later." + err,
                                showModal: true
                            });
                        }
                    );
            }).catch(error => console.error('Error retrieving token :', error));
        }
    }

    sendCampaignFirebaseRequest(newCampaignObjectData) {
        this.props.firebase.company(useUID)
            .collection("campaign")
            .add(newCampaignObjectData)
            .then(() => {
                this.setState({
                    loading: false,
                    modalMessage: "Success!!!",
                    showModal: true
                });
                this.setCompanyLastCampaignTime(newCampaignObjectData.time);
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    modalMessage: "Some error, try again later." + error,
                    showModal: true
                });
                console.error("Error adding document: ", error)
            });
    }

    setCompanyLastCampaignTime(timestamp) {
        this.props.firebase.company(useUID)
            .update("lastCampaigns", timestamp)
            .then(() => console.log("Last Campaign Time Company saved!"))
            .catch(error => console.error("Error Updating Last Campaign Time: ", error));
    }

    handleNewCampaignListUid(listOfUidForNewCampaign) {
        this.setState({campaignsList: listOfUidForNewCampaign});
        this.setState({selectedTabIndex: 4});
    }

    handleDeviceActiveUpdate(guid, active) {
        let activeBoolean = true;
        if (active === "false") {
            activeBoolean = false;
        }
        this.props.firebase.deviceUpdate(useUID, guid).update({active: activeBoolean})
    }

    componentWillUnmount() {
        if (this.unsubScans !== null) this.unsubScans()
        if (this.unsubPredictions !== null) this.unsubPredictions()
        if (this.unsubDevices !== null) this.unsubDevices()
        if (this.unsubStores !== null) this.unsubStores()
        if (this.unsubCampaigns !== null) this.unsubCampaigns()
        if (this.unsubWhoUsedCampaigns !== null) this.unsubWhoUsedCampaigns()
        if (this.companyUnsub !== null) this.companyUnsub()
    }

    handleDateSelect(item) {
        let event = item.selection;
        event.endDate.setHours(23, 59, 59, 999);
        if (event.startDate == event.endDate) {
            return;
        }
        this.setState({
            startDate: new Date(event.startDate),
            endDate: new Date(event.endDate),
        }, () => {
            this.unsubScans = this.fetchScans();
        })
    }

    handleDateSelectCampaigns(item) {
        let event = item.selection;
        event.endDate.setHours(23, 59, 59, 999);
        if (event.startDate == event.endDate) {
            return;
        }
        this.setState({
            startDateCampaigns: new Date(event.startDate),
            endDateCampaigns: new Date(event.endDate),
        }, () => {
            this.fetchCampaigns();
        })
    }

    getDataFromImportCSVComponent(data) {
        this.setState({importDataFromSheet: data});
    };

    closeModal() {
        this.setState({showModal: false});
    };


    render() {
        const {
            company,
            scans,
            loading,
            scansForExport,
            aggregateScans,
            aggregateScansCount,
            aggregateScansPerStore,
            startDate,
            startDateCampaigns,
            endDate,
            endDateCampaigns,
            visits,
            visitsForExport,
            totalValue,
            campaigns,
            campaignsForExport,
            devices,
            stores,
            companyLogoURL,
            campaignLoaded,
            whoUsedCampaignMap,
            whoSeenCampaignMap,
            predictions,
        } = this.state;

        const bulkCampaigns = campaigns.filter(campaign =>
            campaign.numberOfUserToTarget > 1
        );
        const bulkCampaignsForExport = campaignsForExport.filter(campaign =>
            campaign.numberOfUserToTarget > 1
        );

        const privateCampaigns = campaigns.filter(campaign =>
            campaign.numberOfUserToTarget <= 1
        );
        const privateCampaignsForExport = campaignsForExport.filter(campaign =>
            campaign.numberOfUserToTarget <= 1
        );

        const privateGroupedCampaigns = JSON.parse(JSON.stringify(privateCampaigns)).reduce((groups, item) => {
            if (!Array.isArray(groups)) {
                groups = [];
            }
            const filteredByCampaignType = groups.filter(group => group.campaignType === item.campaignType) || [];
            if (filteredByCampaignType.length > 0) {
                filteredByCampaignType[0].numberOfUserToTarget = filteredByCampaignType[0].numberOfUserToTarget + item.numberOfUserToTarget;
                filteredByCampaignType[0].likes = filteredByCampaignType[0].likes.concat(item.likes);
                filteredByCampaignType[0].dislikes = filteredByCampaignType[0].dislikes.concat(item.dislikes);
                filteredByCampaignType[0].userTotal = filteredByCampaignType[0].userTotal + item.userTotal;
                filteredByCampaignType[0].userCountNotificationEnabled = filteredByCampaignType[0].userCountNotificationEnabled + item.userCountNotificationEnabled;
                filteredByCampaignType[0].userCountNotificationDisabled = filteredByCampaignType[0].userCountNotificationDisabled + item.userCountNotificationDisabled;
                filteredByCampaignType[0].userDoesNotHaveToken = filteredByCampaignType[0].userDoesNotHaveToken + item.userDoesNotHaveToken;
                filteredByCampaignType[0].userReceivedNotificationRecently = filteredByCampaignType[0].userReceivedNotificationRecently + item.userReceivedNotificationRecently;
                filteredByCampaignType[0].campaignCost = filteredByCampaignType[0].campaignCost + item.campaignCost;
            } else {
                groups.push(item);
            }
            return groups;
        }, {});
        const privateGroupedCampaignsForExport = JSON.parse(JSON.stringify(privateCampaignsForExport)).reduce((groups, item) => {
            if (!Array.isArray(groups)) {
                groups = [];
            }
            const filteredByCampaignType = groups.filter(group => group.campaignType === item.campaignType) || [];
            if (filteredByCampaignType.length > 0) {
                filteredByCampaignType[0].numberOfUserToTarget = filteredByCampaignType[0].numberOfUserToTarget + item.numberOfUserToTarget;
                filteredByCampaignType[0].likes = filteredByCampaignType[0].likes + (item.likes);
                filteredByCampaignType[0].dislikes = filteredByCampaignType[0].dislikes + (item.dislikes);
                filteredByCampaignType[0].userTotal = filteredByCampaignType[0].userTotal + item.userTotal;
                filteredByCampaignType[0].userCountNotificationEnabled = filteredByCampaignType[0].userCountNotificationEnabled + item.userCountNotificationEnabled;
                filteredByCampaignType[0].userCountNotificationDisabled = filteredByCampaignType[0].userCountNotificationDisabled + item.userCountNotificationDisabled;
                filteredByCampaignType[0].userDoesNotHaveToken = filteredByCampaignType[0].userDoesNotHaveToken + item.userDoesNotHaveToken;
                filteredByCampaignType[0].userReceivedNotificationRecently = filteredByCampaignType[0].userReceivedNotificationRecently + item.userReceivedNotificationRecently;
                filteredByCampaignType[0].campaignCost = filteredByCampaignType[0].campaignCost + item.campaignCost;
            } else {
                groups.push(item);
            }
            return groups;
        }, {});
        const allowedUidForScanImport = ["Io9YuAnCoSO4DmM4zXrfQcSocnq2"];
        return (
            <div>
                {/* Company Header */}
                <div className="dashboard-header">
                    <div className="dashboard-company-info">
                        {companyLogoURL && (
                            <img
                                src={companyLogoURL}
                                alt="Company Logo"
                                className="dashboard-company-logo"
                            />
                        )}
                        <div>
                            <h2 className="dashboard-company-name">
                                {company != null ? company.name : ''}
                            </h2>
                        </div>
                    </div>
                    {loading && (
                        <div className="flex items-center gap-2 text-primary-600">
                            <Spinner animation="border" size="sm" />
                            <span className="text-sm font-medium">Loading...</span>
                        </div>
                    )}
                </div>

                <div>
                    <Tabs selectedIndex={this.state.selectedTabIndex}
                          onSelect={tabIndex => this.setState({selectedTabIndex: tabIndex})}>
                        <TabList>
                            <Tab>Scans</Tab>
                            <Tab>Visits</Tab>
                            <Tab>Segments</Tab>
                            <Tab>Campaigns</Tab>
                            <Tab>Create New Campaigns</Tab>
                            <Tab>Vouchers</Tab>
                            <Tab>Loyalty Analytics</Tab>
                            <Tab>Devices</Tab>
                            <Tab>QR Code</Tab>
                            {allowedUidForScanImport.includes(useUID) && <Tab>Dodaj Kupovine</Tab>}
                        </TabList>
                        <TabPanel>
                            {/* Date Range Section */}
                            <div className="date-display">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                {Moment.tz(startDate, 'Europe/Belgrade').format('DD.MM.YYYY')} - {Moment.tz(endDate, 'Europe/Belgrade').format('DD.MM.YYYY')}
                            </div>

                            <div className="date-range-container">
                                <DateRangePicker
                                    ranges={[{startDate: startDate, endDate: endDate, key: 'selection'}]}
                                    moveRangeOnFirstSelection={true}
                                    weekStartsOn={1}
                                    onChange={this.handleDateSelect}
                                />
                            </div>

                            {/* Stats Cards */}
                            <div className="stats-grid">
                                <div className="stats-card">
                                    <div className="stats-card-label">Total Scans</div>
                                    <div className="stats-card-value">{scans.length}</div>
                                </div>
                                <div className="stats-card">
                                    <div className="stats-card-label">Total Value</div>
                                    <div className="stats-card-value">
                                        <NumberFormat value={Math.round(totalValue * 100) / 100} displayType={'text'}
                                                      thousandSeparator={true} />
                                    </div>
                                </div>
                                <div className="stats-card">
                                    <div className="stats-card-label">Days Tracked</div>
                                    <div className="stats-card-value">{aggregateScansCount.length}</div>
                                </div>
                            </div>

                            {/* Charts Row */}
                            <div className="charts-row">
                                <div className="chart-container chart-small">
                                    <div className="chart-title">Value per Day</div>
                                    <ResponsiveContainer width="99%" height={200}>
                                        <BarChart data={aggregateScans}
                                                  margin={{top: 5, right: 10, left: 0, bottom: 5}}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb"/>
                                            <XAxis dataKey="name" tick={{fontSize: 10}}/>
                                            <YAxis tick={{fontSize: 10}}/>
                                            <Tooltip/>
                                            <Bar dataKey="value" fill="#6366f1" radius={[4, 4, 0, 0]}/>
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>

                                <div className="chart-container chart-small">
                                    <div className="chart-title">Count per Day</div>
                                    <ResponsiveContainer width="99%" height={200}>
                                        <BarChart data={aggregateScansCount}
                                                  margin={{top: 5, right: 10, left: 0, bottom: 5}}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb"/>
                                            <XAxis dataKey="name" tick={{fontSize: 10}}/>
                                            <YAxis tick={{fontSize: 10}}/>
                                            <Tooltip/>
                                            <Bar dataKey="count" fill="#10b981" radius={[4, 4, 0, 0]}/>
                                            <Bar dataKey="uniquePerDay" fill="#6366f1" radius={[4, 4, 0, 0]}/>
                                            <Bar dataKey="uniqueForPeriod" fill="#f59e0b" radius={[4, 4, 0, 0]}/>
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>

                                <div className="chart-container chart-small">
                                    <div className="chart-title">Count per Store ({aggregateScansPerStore.length})</div>
                                    <ResponsiveContainer width="99%" height={200}>
                                        <BarChart data={aggregateScansPerStore}
                                                  margin={{top: 5, right: 10, left: 0, bottom: 5}}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb"/>
                                            <XAxis dataKey="storeName" tick={{fontSize: 8}} interval={0} angle={-45} textAnchor="end" height={60}/>
                                            <YAxis tick={{fontSize: 10}}/>
                                            <Tooltip content={<StoresTooltip/>}/>
                                            <Bar dataKey="count" fill="#10b981" radius={[4, 4, 0, 0]}/>
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>

                            <Scans
                                scans={scans}
                                handleNewCampaignListUid={this.handleNewCampaignListUid}
                                fetchScansByUids={this.fetchScansByUids}
                                exportRawButton={<ExportCSV csvData={scansForExport} fileName={company != null ? company.name : 'EmptyFile'}/>}
                            />
                        </TabPanel>
                        <TabPanel>
                            {/* Actions Bar */}
                            <div className="flex flex-wrap items-center gap-3 mb-4 p-4 bg-gray-50 rounded-lg">
                                <Button variant="primary" onClick={() => this.fetchVisitsWithoutListener()}
                                        className="btn btn-primary">
                                    Refresh Visits
                                </Button>
                                <Button variant="outline-primary" onClick={() => this.fetchVisitsWithoutListener(true)}>
                                    Load More
                                </Button>
                                <div className="ml-auto flex items-center gap-2">
                                    <span className="text-sm text-gray-500">Loaded:</span>
                                    <span className="font-semibold text-gray-900">{visits.length}</span>
                                </div>
                            </div>

                            <Visits
                                visits={visits}
                                handleNewCampaignListUid={this.handleNewCampaignListUid}
                                company={company}
                                fetchVisitsByUids={this.fetchVisitsByUids}
                                exportRawButton={<ExportCSV csvData={visitsForExport} fileName={company != null ? "Visits" + company.name : 'VisitsEmptyFile'}/>}
                            />
                        </TabPanel>
                        <TabPanel>
                            {/* Segments Tab */}
                            <div className="flex flex-wrap items-center gap-3 mb-4 p-4 bg-gray-50 rounded-lg">
                                <Button variant="primary" onClick={() => this.fetchVisitsWithoutListener()}>
                                    Refresh Data
                                </Button>
                                <Button variant="outline-primary" onClick={() => this.fetchVisitsWithoutListener(true)}>
                                    Load More
                                </Button>
                                <div className="ml-auto flex items-center gap-2">
                                    <span className="text-sm text-gray-500">Loaded:</span>
                                    <span className="font-semibold text-gray-900">{visits.length}</span>
                                </div>
                            </div>

                            <Segments
                                visits={visits}
                                handleNewCampaignListUid={this.handleNewCampaignListUid}
                                company={company}
                            />
                        </TabPanel>
                        <TabPanel>
                            {/* Actions Bar */}
                            <div className="flex flex-wrap items-center gap-3 mb-4 p-4 bg-gray-50 rounded-lg">
                                <Button variant="primary" onClick={() => this.fetchCampaigns()}>
                                    Load Campaigns
                                </Button>
                                <div className="date-display">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    {Moment.tz(startDateCampaigns, 'Europe/Belgrade').format('DD.MM.YYYY')} - {Moment.tz(endDateCampaigns, 'Europe/Belgrade').format('DD.MM.YYYY')}
                                </div>
                            </div>

                            <div className="date-range-container">
                                <DateRangePicker
                                    ranges={[{
                                        startDate: startDateCampaigns,
                                        endDate: endDateCampaigns,
                                        key: 'selection'
                                    }]}
                                    moveRangeOnFirstSelection={true}
                                    weekStartsOn={1}
                                    onChange={this.handleDateSelectCampaigns}
                                />
                            </div>

                            {/* Load by Campaign IDs */}
                            <div className="flex items-center gap-3 mb-4 p-4 bg-gray-100 rounded-lg">
                                <span className="text-sm text-gray-600">Učitaj po ID-jevima:</span>
                                <input
                                    type="text"
                                    placeholder="id1,id2,id3..."
                                    value={this.state.campaignIdsInput}
                                    onChange={(e) => this.setState({campaignIdsInput: e.target.value})}
                                    className="border border-gray-300 rounded px-3 py-2 text-sm flex-1"
                                />
                                <Button variant="outline-secondary" onClick={() => this.fetchCampaignsByIds(this.state.campaignIdsInput)}>
                                    Load by IDs
                                </Button>
                            </div>

                            {/* Campaign Sub-Tabs */}
                            <Tabs selectedIndex={this.state.selectedCampaignSubTab}
                                  onSelect={index => this.setState({selectedCampaignSubTab: index})}>
                                <TabList>
                                    <Tab>Bulk ({bulkCampaigns.length})</Tab>
                                    <Tab>Private ({privateCampaigns.length})</Tab>
                                    <Tab>Private Grouped ({privateGroupedCampaigns.length})</Tab>
                                </TabList>

                                <TabPanel>
                                    <Campaigns campaigns={bulkCampaigns} loadWhoUsedCampaign={this.fetchWhoUsedCampaign}
                                               loadWhoSeenCampaign={this.fetchWhoSeenCampaign}
                                               companyUid={useUID}
                                               exportRawButton={<ExportCSV csvData={bulkCampaignsForExport}
                                                   fileName={company != null ? "CampaignsBulk_" + company.name : 'CampaignsEmptyFile'}/>}/>
                                </TabPanel>

                                <TabPanel>
                                    <Campaigns campaigns={privateCampaigns} loadWhoUsedCampaign={this.fetchWhoUsedCampaign}
                                               loadWhoSeenCampaign={this.fetchWhoSeenCampaign}
                                               companyUid={useUID}
                                               exportRawButton={<ExportCSV csvData={privateCampaignsForExport}
                                                   fileName={company != null ? "CampaignsPrivate_" + company.name : 'CampaignsEmptyFile'}/>}/>
                                </TabPanel>

                                <TabPanel>
                                    <Campaigns campaigns={privateGroupedCampaigns}
                                               loadWhoUsedCampaign={this.fetchWhoUsedCampaign}
                                               loadWhoSeenCampaign={this.fetchWhoSeenCampaign}
                                               companyUid={useUID}
                                               exportRawButton={<ExportCSV csvData={privateGroupedCampaignsForExport}
                                                   fileName={company != null ? "CampaignsPrivateGrouped_" + company.name : 'CampaignsEmptyFile'}/>}/>
                                </TabPanel>
                            </Tabs>
                        </TabPanel>
                        <TabPanel>
                            <CrateCampaignsLayout sendCampaigns={this.sendCampaigns}
                                                  companyData={company}
                                                  scans={scans}
                                                  visits={visits}
                                                  campaigns={campaigns}
                                                  newCampaignsListUid={this.state.campaignsList}
                                                  companyLogoURL={this.state.companyLogoURL}
                                                  loading={loading}/>
                            {/*<ImportCSV sendData={this.getDataFromImportCSVComponent} importFormat={importedFormatOfCsvFile.arrayWithObject}/>*/}
                            {/*<DkTable data={this.state.importDataFromSheet}/>*/}
                        </TabPanel>
                        <TabPanel>
                            {/* Vouchers Analytics */}
                            <VoucherAnalytics voucherReport={this.state.voucherReport} />
                        </TabPanel>
                        <TabPanel>
                            {/* Loyalty Analytics */}
                            <LoyaltyAnalytics analyticsReport={this.state.analyticsReport} />
                        </TabPanel>
                        <TabPanel>
                            <Devices devices={devices} handleDeviceActiveUpdate={this.handleDeviceActiveUpdate}
                                     stores={stores}/>
                        </TabPanel>
                        <TabPanel>
                            <GenerateBillQRCode/>
                        </TabPanel>
                        {allowedUidForScanImport.includes(useUID) && <TabPanel>
                            <CSVUploadComponent firebase={this.props.firebase} />
                        </TabPanel>}
                    </Tabs>
                </div>
                <Modal showing={this.state.showModal} closeModal={this.closeModal}>
                    <Message message={this.state.modalMessage}/>
                </Modal>
            </div>
        );
    }
}

class CustomTooltip extends React.Component {
    render() {
        const {active} = this.props;

        if (active) {
            const {payload, label} = this.props;
            if (payload === null) {
                return null;
            }
            return (
                <div className="custom-tooltip">
                    <p className="value">Value: {payload[0].value}</p>
                    <p className="value">Time: {payload[0].payload["time"]}</p>
                    <p className="value">Date: {payload[0].payload["date"]}</p>
                    <p className="value">Bill: {payload[0].payload["billNumber"]}</p>
                    <p className="value">Company Code: {payload[0].payload["companyCode"]}</p>
                    <p className="value">City: {payload[0].payload["city"]}</p>
                    <p className="value">Country: {payload[0].payload["country"]}</p>
                    <p className="value">Status: {payload[0].payload["status"]}</p>
                    <p className="value">Pos Id: {payload[0].payload["posId"]}</p>
                    <p className="value">Pos username: {payload[0].payload["username"]}</p>
                </div>
            );
        }
        return null;
    }
}

class StoresTooltip extends React.Component {
    render() {
        const {active} = this.props;

        if (active) {
            const {payload, label} = this.props;
            if (payload === null) {
                return null;
            }
            return (
                <div className="custom-tooltip">
                    <p className="value">Value: {payload[0].value}</p>
                    <p className="value">Zip: {payload[0].payload["city"]}</p>
                    <p className="value">Store id: {payload[0].payload["storeId"]}</p>
                    <p className="value">Name: {payload[0].payload["storeName"]}</p>
                </div>
            );
        }
        return null;
    }
}

const ValueCampaignForm = withFirebase(ValueCampaignFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(DashboardPage);
